import { DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { IObjBusquedaCalendarizacion, IObjProceso, IReqBodyCrearCalendarizacion, IReqBodyEditarCalendarizacion, IResBody, IResObtenerProcesos } from 'src/app/interfaces/calendarizacion';
import { IAnyos, IPeriodos } from 'src/app/interfaces/portal-calificaciones';
import { CalendarizacionService } from 'src/app/services/calendarizacion/calendarizacion.service';
import { PortalCalificacionesService } from 'src/app/services/portal-calificaciones/portal-calificaciones';

@Component({
  selector: 'app-view-calendario-procesos-crear',
  templateUrl: './view-calendario-procesos-crear.component.html',
  styleUrls: ['./view-calendario-procesos-crear.component.scss']
})
export class ViewCalendarioProcesosCrearComponent {
  filtroAnyo: number = 0
  filtroPeriodo: number = 0
  filtroProceso: number = 0

  fechaInicio: any = ''
  fechaFin: any = ''
  descripcion: string = ''

  listaAnyo: Array<number> = []
  listaPeriodo: any = []
  listaProceso: any = []

  tieneErrores: any = {}
  submitted: boolean = false

  filtrosCargados: any = {}
  dataCalendarizacion = {} as IObjBusquedaCalendarizacion
  formEdit: boolean = false

  errorMsg: string = ''

  parametrosForm = this.formBuilder.group({
    anyo: ['0', [Validators.required]],
    periodo: ['0', [Validators.required]],
    proceso: ['0', [Validators.required]],
    descripcion: ['', []],
    fechaInicio: ['', []],
    fechaFin: ['', []],
  })

  constructor(
    private _calendarizacion: CalendarizacionService,
    private formBuilder: FormBuilder,
    private _portalServices: PortalCalificacionesService,
    private router: Router,
    private datePipe: DatePipe
  ) {
    const routerData = this.router.getCurrentNavigation()?.extras?.state?.['data']
    if ( routerData?.editar && routerData?.calendarizacion ) {
      this.formEdit = true
      this.dataCalendarizacion = routerData?.calendarizacion

      let arrFechaInicio = this.dataCalendarizacion.fechaInicio.split('/');
      let convertedInicioDate = new Date(arrFechaInicio[1]+'-'+arrFechaInicio[0]+' '+arrFechaInicio[2])
      this.fechaInicio = this.datePipe.transform(convertedInicioDate, 'yyyy-MM-dd')

      let arrfechaFin = this.dataCalendarizacion.fechaTermino.split('/');
      let convertedFinDate = new Date(arrfechaFin[1]+'-'+arrfechaFin[0]+' '+arrfechaFin[2])
      this.fechaFin = this.datePipe.transform(convertedFinDate, 'yyyy-MM-dd')

      this.descripcion = this.dataCalendarizacion.descripcion
      
      this.parametrosForm.get('anyo')?.disable()
      this.parametrosForm.get('periodo')?.disable()
      this.parametrosForm.get('proceso')?.disable()
    }
    if (routerData?.filtros) {
      this.filtrosCargados = routerData.filtros
    }

    this.obtenerAnyos()
    this.obtenerProcesos()
  }

  navToCalendarizacion() {
    if ( this.formEdit ) {
      this.router.navigate(['/calendario-inicio'], {
        state: {
          data: {
            filtros: {
              anyo: this.filtroAnyo,
              periodoId: this.filtroPeriodo
            }
          }
        }
      })
    } else {
      this.router.navigate(['/calendario-inicio'])
    }
  }

  resetearValidacion(tipo: string = 'default') {
    this.submitted = false
    this.tieneErrores["anyo"] = false
    this.tieneErrores["periodo"] = false
    this.tieneErrores["proceso"] = false
    this.tieneErrores["fechaInicio"] = false
    this.tieneErrores["fechaFin"] = false
    this.tieneErrores["descripcion"] = false
  }

  limpiarFiltros() {
    this.filtroAnyo = 0
    this.filtroPeriodo = 0
    this.filtroProceso = 0
    this.fechaInicio = ''
    this.fechaFin = ''
    this.descripcion = ''

    this.submitted = false
    this.tieneErrores = []
  }

  cargarFiltros(filtro: string): void {
    if ( this.filtroAnyo === 0 && this.filtroPeriodo === 0 && this.filtroPeriodo === 0 ) {
      return
    }
    switch (filtro) {
      case "anyo":
        this.obtenerPeriodos(this.filtroAnyo)
        break;
      case "periodo":
        break;
      case "proceso":
        break;
      default:
        break;
    }
  }

  obtenerAnyos(): void {
    this._portalServices.obtenerListaAnhos().subscribe((res: IAnyos) => {
      this.listaAnyo = res.anyos
      if ( this.filtrosCargados?.anyo ) {
        this.filtroAnyo = this.filtrosCargados?.anyo
        delete this.filtrosCargados.anyo
      }
    })
  }

  obtenerProcesos(): void {
    this._calendarizacion.getProcesos().subscribe((res: IResObtenerProcesos) => {
      this.listaProceso = res
      if ( this.filtrosCargados?.proceso ) {
        this.filtroProceso = this.filtrosCargados?.proceso
        delete this.filtrosCargados.proceso
      }
    })
  }

  obtenerPeriodos(filtroAnyo: number, tipo: string = ''): void {
    this.filtroPeriodo = 0

    if ( filtroAnyo !== 0 ) {
      this.tieneErrores["anyo"] = false
      this._portalServices.obtenerListaPeriodos(filtroAnyo).subscribe(
        (res: IPeriodos) => {
          this.listaPeriodo = res.periodos
          if (this.filtrosCargados?.periodoId) {
            this.filtroPeriodo = this.filtrosCargados.periodoId
            delete this.filtrosCargados.periodoId
          }
        }
      )
    }
  }

  fnTieneErrores() {
    if ( this.fechaInicio.toString() === '' ) this.tieneErrores["fechaInicio"] = true
    if ( this.fechaFin.toString() === '' ) this.tieneErrores["fechaFin"] = true
    if ( this.descripcion === '' ) this.tieneErrores["descripcion"] = true
    if ( this.filtroAnyo == 0 ) this.tieneErrores["anyo"] = true
    if ( this.filtroPeriodo == 0 ) this.tieneErrores["periodo"] = true
    if ( this.filtroProceso == 0 ) this.tieneErrores["proceso"] = true
  }

  crear() {
    this.submitted = true
    this.fnTieneErrores()
    const filtrosConErrores = Object.values(this.tieneErrores).filter(value => value === true)
    if ( filtrosConErrores.length > 0 ) {
      return
    }

    const body: IReqBodyCrearCalendarizacion = {
      procesoId: +this.filtroProceso,
      anoAcademico: +this.filtroAnyo,
      periodoAcademicoId: +this.filtroPeriodo,
      descripcion: this.descripcion,
      fechaInicio: `${this.fechaInicio.toString().split('-')[2]}/${this.fechaInicio.toString().split('-')[1]}/${this.fechaInicio.toString().split('-')[0]} 00:00:00`,
      fechaTermino: `${this.fechaFin.toString().split('-')[2]}/${this.fechaFin.toString().split('-')[1]}/${this.fechaFin.toString().split('-')[0]} 23:59:00`
    }

    if ( !this.formEdit ) {
      this._calendarizacion.postCrearCalendarizacion(body).subscribe((res: IResBody) => {
        if ( res.error === null ) {
          const procesoActual = this.listaProceso.filter((proceso: IObjProceso) => proceso.procesoId == this.filtroProceso)
          this.router.navigate(['/calendario-inicio'], {
            state: {
              data: {
                calendarizacionCreada: true,
                nombreProceso: procesoActual[0].codigoProceso
              }
            }
          })
        } else {
          this.errorMsg = res?.error?.mensaje ?? 'Hubo un error en los servicios'
          setTimeout(() => {
            this.errorMsg = ''
          }, 15000);
        }
      })
    } else {
      const bodyEdit: IReqBodyEditarCalendarizacion = {
        calendarizacionId: this.dataCalendarizacion.calendarizacionId,
        descripcion: this.descripcion,
        fechaInicio: `${this.fechaInicio.toString().split('-')[2]}/${this.fechaInicio.toString().split('-')[1]}/${this.fechaInicio.toString().split('-')[0]} 00:00:00`,
        fechaTermino: `${this.fechaFin.toString().split('-')[2]}/${this.fechaFin.toString().split('-')[1]}/${this.fechaFin.toString().split('-')[0]} 23:59:00`
      }
      this._calendarizacion.postEditarCalendarizacion(bodyEdit).subscribe((res: IResBody) => {
        if ( res.error === null ) {
          const procesoActual = this.listaProceso.filter((proceso: IObjProceso) => proceso.procesoId == this.filtroProceso)
          this.router.navigate(['/calendario-inicio'], {
            state: {
              data: {
                calendarizacionEditada: true,
                nombreProceso: procesoActual[0].codigoProceso,
                filtros: {
                  anyo: this.filtroAnyo,
                  periodoId: this.filtroPeriodo,
                  proceso: this.filtroProceso
                }
              }
            }
          })
        } else {
          this.errorMsg = res?.error?.mensaje ?? 'Hubo un error en los servicios'
          setTimeout(() => {
            this.errorMsg = ''
          }, 15000);
        }
      })
    }
  }
}
